export default __webpack_public_path__ + "static/media/Turntable-comp.5ab91380.gif";